import type { FC } from 'react';

import { ImageComponent } from '@/components/Image';
import type { PoolLevelEnum } from '@/helpers/jackpot';

import { ScAnimatedCrystal } from './styled';

interface IAnimatedCrystalProps {
  type: PoolLevelEnum;
  size?: number;
}

export const AnimatedCrystal: FC<IAnimatedCrystalProps> = ({
  type,
  size = 80,
}) => {
  const commonImageProps = {
    width: size,
    height: size,
    alt: `${type} crystal`,
  };

  return (
    <ScAnimatedCrystal>
      <div className="crystal-1">
        <ImageComponent
          src={`/jackpot/levels/${type}1.webp`}
          {...commonImageProps}
        />
      </div>
      <div className="crystal-2">
        <ImageComponent
          src={`/jackpot/levels/${type}2.webp`}
          {...commonImageProps}
        />
      </div>
    </ScAnimatedCrystal>
  );
};
